import { mlflowApiClient } from '@/shared/api/core/axios-instance';

import type { SetModelTagRequest } from '@/entities/registered-model/domain';

export const updateModelTag = async (request: SetModelTagRequest): Promise<void> => {
  await mlflowApiClient.post('/ajax-api/2.0/mlflow/registered-models/set-tag', request);
};
